import { Fragment } from 'react';

import useClubGroupPracticeAdd from './UseClubGroupPracticeAdd';

import ClubGroupsLoadingModal from '../../components/dialogs/loadingModal/ClubGroupsLoadingModal';

import Headings from '@usas/ui-web/components/headings/Headings';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import GroupInfoForm from '@usas/ui-web/components/forms/groups/GroupInfoForm';
import PracticeAttributesForm from '@usas/ui-web/components/forms/groups/PracticeAttributesForm';

import { LOADING_MSG, SAVING_MSG } from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ClubGroupPracticeAdd = () => {
  const {
    isSaving,
    isLoading,
    state,
    formState,
    errorState,
    handleSubmit,
    onFormValueChanged,
    onValueTextPairChanged,
    onBackClicked,
    orgUnitId
  } = useClubGroupPracticeAdd();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Add Practice Group</Headings.H3>
        </div>
      </div>
      <form onSubmit={handleSubmit} noValidate>
        <GroupInfoForm
          formState={formState}
          errorState={errorState}
          onFormValueChanged={onFormValueChanged}
          orgUnitId={orgUnitId}
          attributeForm={<PracticeAttributesForm
            formState={formState}
            errorState={errorState}
            orgUnitId={orgUnitId}
            onFormValueChanged={onFormValueChanged}
            onValueTextPairChanged={onValueTextPairChanged}
            alwaysGetFacilities={true} />
          } />
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <PrimaryButton type="submit">Create Group</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>
            {errorState && errorState.errorOnSubmitAction
              && <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction}</p>
            }
          </div>
        </div>
      </form>
      <ClubGroupsLoadingModal
        isLoading={isLoading || isSaving}
        loadingMessage={isSaving ? SAVING_MSG : LOADING_MSG}
        isError={state.pageErrorMessage !== ''}
        errorMessage={state.pageErrorMessage} />
    </Fragment>
  );
};

export default ClubGroupPracticeAdd;